import { useQuery } from '@tanstack/react-query'

import { listRichMenuTemplates } from 'api/richMenu'
import { queryKeys } from 'constants/queryKeys'
import { lineStrings } from 'constants/strings'
import { useAuth } from 'contexts/AuthContext'
import { toErrorMessage } from 'hooks/utils'
import type { TRichMenuTemplate } from 'types'

type UseRichMenuTemplatesResult = {
  templates: TRichMenuTemplate[]
  loading: boolean
  error: string | undefined
}

export function useRichMenuTemplates(): UseRichMenuTemplatesResult {
  const { user } = useAuth()

  const query = useQuery({
    queryKey: [queryKeys.RICH_MENU_TEMPLATES, user?.uid],
    enabled: Boolean(user?.uid),
    queryFn: listRichMenuTemplates,
    retry: false,
  })

  return {
    templates: query.data?.templates ?? [],
    loading: Boolean(user?.uid) && query.isPending,
    error: query.error
      ? toErrorMessage(
          query.error,
          lineStrings.management.richMenu.create.errors.loadTemplatesFailed,
        )
      : undefined,
  }
}
